import { render, staticRenderFns } from "./QuitaList.vue?vue&type=template&id=1ee5f696&scoped=true"
import script from "./QuitaList.vue?vue&type=script&lang=js"
export * from "./QuitaList.vue?vue&type=script&lang=js"
import style0 from "./QuitaList.vue?vue&type=style&index=0&id=1ee5f696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee5f696",
  null
  
)

export default component.exports